import { useEffect, useState } from "react";
import "./Countdown.css";
import FlipCard from "./FlipCard";
const Countdown = ({ startTime }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const COUNTDOWN_DATE = new Date(startTime).getTime();
      const now = new Date().getTime();
      const difference = COUNTDOWN_DATE - now;

      if (difference <= 0) {
        setIsVisible(false);
        return null;
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000),
      };
    };

    const updateCountdown = () => {
      const newTimeLeft = calculateTimeLeft();
      if (newTimeLeft) {
        setTimeLeft(newTimeLeft);
      }
    };

    const timer = setInterval(updateCountdown, 1000);
    updateCountdown();

    return () => clearInterval(timer);
  }, [startTime]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="countdown-wrapper">
      <div className={`st-title ${!isVisible ? "hidden" : ""}`}>SHOWTIME</div>
      <div className="st-countdown-container">
        <FlipCard value={timeLeft.days} isRed={timeLeft.days === 0} />
        <FlipCard
          value={timeLeft.hours}
          isRed={timeLeft.days === 0 && timeLeft.hours === 0}
        />
        <FlipCard
          value={timeLeft.minutes}
          isRed={
            timeLeft.days === 0 &&
            timeLeft.hours === 0 &&
            timeLeft.minutes === 0
          }
        />
        <FlipCard
          value={timeLeft.seconds}
          isRed={
            timeLeft.days === 0 &&
            timeLeft.hours === 0 &&
            timeLeft.minutes === 0 &&
            timeLeft.seconds === 0
          }
        />
      </div>
    </div>
  );
};
export default Countdown;
